import React, { useEffect, useState } from 'react'
import { FormBox, InputBox } from '../../../../components/AntdAddons'
import { Button, Checkbox, Col, Divider, Form, Row } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../../store/app'
import { rules } from './Rules'
import { useNavigate } from 'react-router-dom'
import { doLogin, setSessionTimeOut, sendUserOtp } from '../../../../store/AuthSlice'
import { assignErrorToInput } from '../../../../store/api'
import { mobilePattern, stringDecryption, Notification } from '../../../../config/Global'
import loginlogo from "../../../../assets/images/login-logo.svg"
import loginbgMob from "../../../../assets/images/login-img-new-mobile.svg"
import VerifyAccount from "../VerifyAccount/VerifyAccount";
import { getCookie } from "../../../../config/Global";
import { WebConstant } from '../../webConstant/WebConstant'
/**
 * Renders the Login component contains login form.
 *
 * @return {JSX.Element} The rendered WebLogin component.
 */
const WebLogin = () => {
    const [form] = Form.useForm();
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);

    const [rememberMe, setRememberMe] = useState(false);
    const [rememberMeOTP, setRememberMeOTP] = useState('');
    const [verificationData, setVerificationData] = useState<any>(null);
    const [isVerification, setIsVerification] = useState(false);
    const bannerContent = useSelector((state: RootState) => state.HOME?.pageSettings)
    const [isRemembered, setIsRemembered] = useState<any>(null);

    const location = useLocation();
    // Submit Login Form and navigate to dashboard
    const handleSubmit = (data: any) => {
        setLoading(true);
        if (
            isRemembered != null &&
            rememberMe &&
            data.username == isRemembered?.email &&
            data.password == isRemembered?.password
        ) {
            const req = {
                username: data.username,
                password: data.password,
                remember: true
            };
            dispatch(doLogin(req, 'direct'))
                .then(() => {
                    navigate("/dashboard");
                    dispatch(setSessionTimeOut(true))
                })
                .catch((error: any) => {
                    setLoading(false);
                    assignErrorToInput(form, error?.STATUS)
                })
        }
        else {
            setUSerOtp(data)
        }
    }

    const setUSerOtp = (data: any) => {
        dispatch(sendUserOtp(data))
            .then((response: any) => {
                Notification.success({
                    message: "Code sent on your email/phone.",
                });
                setVerificationData({
                    username: data.username,
                    password: data.password,
                    remember: rememberMe,
                })
                setIsVerification(true);
                setLoading(false);

            })
            .catch((error: any) => {
                setLoading(false);
                assignErrorToInput(form, error?.STATUS)
            })
    }

    useEffect(() => {
        setIsVerification(false);
    }, [location])

    // set User credentials in login form from local storage
    useEffect(() => {

        localStorage.removeItem("feedback");

        // let rememberMeVar: any = localStorage.getItem("remember_me");
        let rememberMeVar: any = getCookie('remember_me');
        if (rememberMeVar) {
            rememberMeVar = JSON.parse(stringDecryption(rememberMeVar));
            console.log('rememberMeVar', rememberMeVar)
            form.setFieldsValue({
                username: rememberMeVar.email,
                password: rememberMeVar.password,
                remember: true,
            });
            setRememberMe(true)
            setIsRemembered(rememberMeVar);
        }
    }, [form]);

    const logo = useSelector((state: RootState) => state.HOME.pageSettings?.banner?.banner_logo)



    return (
        <>
            <section className={`webLoginSection ${isVerification ? 'webForgotPassword' : ''}`}>

                <Row className='no-gutter'>
                    <Col xxl={12} xl={12} lg={12} md={24} sm={24}>
                        <div className="login-bg">
                            <div className="login-bg-in"><img src={loginbgMob} alt="" /></div>
                        </div>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={24} className='form-col'>
                        {!isVerification ? <div className='webLoginBox'>
                            <div className="login-logo">
                                <Link to={'https://www.iwnlenergy.com/'}>
                                    <img src={WebConstant?.IMAGE_URL + logo} alt="" />
                                </Link>
                            </div>
                            <h2 className="subtitle">Welcome Back</h2>
                            <p>Log in to continue your energy journey.</p>
                            <FormBox form={form} onFinish={handleSubmit}>
                                <InputBox.Text
                                    name="username"
                                    label={<>Email or Phone <em>*</em></>}
                                    placeholder=''
                                    className='ecn-input'

                                    rules={rules.username()}
                                    onChange={(e: any) => {

                                        if (!/[a-zA-Z]/.test(e.target.value) && e.target.value.length >= 0) {

                                            form.setFieldsValue({ username: mobilePattern(e.target.value) })
                                        }
                                    }}
                                // onChange={(e) => )}
                                />
                                <InputBox.Password
                                    name="password"
                                    label={<>Password <em>*</em></>}
                                    placeholder=''

                                    className='ecn-input'
                                    rules={rules.password()}

                                />
                                <div className='forgetPass'>
                                    <Row align={"middle"} >
                                        <Col sm={12} xs={12} md={12} xxl={12}>
                                            <Checkbox name='remember_me' className='rememberMe' checked={rememberMe} onChange={() => setRememberMe(!rememberMe)}>Remember me</Checkbox>
                                        </Col>
                                        <Col sm={12} xs={12} md={12} xxl={12} className='forgotPassLink'>
                                            <Link to="/forgot-password">Forgot Password</Link>
                                        </Col>
                                    </Row>
                                    <div className='logInBtn'>
                                        <Button 
                                        className='log_in_button secondry_btn_log_page green-btn' 
                                        htmlType='submit'
                                        loading={loading}
                                        >
                                            Sign in
                                        </Button>
                                    </div>
                                    <Divider>or</Divider>
                                    <h5 className='register_here'>Don’t Have An Account?<span onClick={() => navigate("/register")}>Sign up</span></h5>
                                </div>
                            </FormBox>
                        </div>
                            :
                            <VerifyAccount verificationData={verificationData} />}
                    </Col>
                </Row>


            </section>
        </>
    )
}



export default WebLogin